import React from 'react'

import { Instagram } from '@styled-icons/fa-brands/Instagram'

import social from '../../mocks/social'
import Title from '../Title'
import * as S from './styled'

const Social = () => (
  <S.SocialWrapper>
    <Title appearance="tiny" color="light">
      Siga nas redes sociais:
    </Title>
    <S.SocialList>
      {social.map((link, i) => {
        return (
          <S.SocialItem key={i}>
            <S.SocialLink
              href={link.url}
              title={link.label}
              target="_blank"
              rel="noopener noreferrer"
            >
              <S.SocialIcon>
                <Instagram size={20} />
              </S.SocialIcon>
              {link.label}
            </S.SocialLink>
          </S.SocialItem>
        )
      })}
    </S.SocialList>
  </S.SocialWrapper>
)

export default Social
